const serveList = () => import('@/views/main/serve/list/list.vue')
export default {
  path: '/main/serve/list',
  name: 'serveList',
  component: serveList,
  children: []
}
